import { render, staticRenderFns } from "./CalendarEvents.vue?vue&type=template&id=03c4e5ae&"
import script from "./CalendarEvents.vue?vue&type=script&lang=js&"
export * from "./CalendarEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports